var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRibonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1559 11.5581L10.9513 10.499C10.4758 10.3415 10.4758 9.65704 10.9513 9.49962L14.1559 8.44046C14.3702 8.36994 14.4879 8.1356 14.4179 7.91764L14.1685 7.13698C14.0992 6.91902 13.8688 6.79936 13.6545 6.87059L10.4498 7.92975C9.97432 8.08717 9.57864 7.53301 9.87207 7.12131L11.8526 4.3484C11.9849 4.1632 11.9443 3.90322 11.7622 3.7686L11.1088 3.28567C10.9268 3.15105 10.6711 3.19236 10.5388 3.37755L8.55827 6.15047C8.26414 6.56217 7.62404 6.35062 7.62404 5.84205V2.41526C7.62404 2.18591 7.44126 2 7.21576 2H6.40829C6.18278 2 6 2.18591 6 2.41526V17.5847C6 17.8141 6.18278 18 6.40829 18H7.21576C7.44126 18 7.62404 17.8141 7.62404 17.5847V14.1579C7.62404 13.6494 8.26414 13.4378 8.55827 13.8495L10.5388 16.6224C10.6711 16.8076 10.9261 16.849 11.1088 16.7143L11.7622 16.2314C11.9443 16.0968 11.9849 15.8368 11.8526 15.6516L9.87207 12.8787C9.57794 12.467 9.97362 11.9128 10.4498 12.0702L13.6545 13.1294C13.8688 13.1999 14.0992 13.081 14.1685 12.863L14.4179 12.0816C14.4872 11.8637 14.3702 11.6293 14.1559 11.5588V11.5581Z",
    fill: "#1D8158"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibonIcon);
export default __webpack_public_path__ + "static/media/ribon-icon.a30ec6fa31830a7ff321270398f4c926.svg";
export { ForwardRef as ReactComponent };